module.exports = __webpack_public_path__ + "img/partner_img16.808adbe7.png";